module.exports = __webpack_public_path__ + "img/cover-MD.ebc55436.jpg";